var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.499 7.56292L8.8806 13.8051C8.0698 14.5698 6.97011 14.9994 5.82346 14.9994C4.67681 14.9994 3.57712 14.5698 2.76631 13.8051C1.95551 13.0404 1.5 12.0032 1.5 10.9217C1.5 9.84027 1.95551 8.8031 2.76631 8.03839L9.38473 1.79622C9.92526 1.28641 10.6584 1 11.4228 1C12.1873 1 12.9204 1.28641 13.4609 1.79622C14.0015 2.30602 14.3051 2.99747 14.3051 3.71845C14.3051 4.43943 14.0015 5.13088 13.4609 5.64069L6.8353 11.8829C6.56504 12.1378 6.19847 12.281 5.81626 12.281C5.43404 12.281 5.06748 12.1378 4.79721 11.8829C4.52694 11.628 4.3751 11.2822 4.3751 10.9217C4.3751 10.5613 4.52694 10.2155 4.79721 9.96062L10.9115 4.20071",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.e8a35098ebc5de926c45e41c80efc052.svg";
export { ForwardRef as ReactComponent };